// src/components/Booking/Calendar.js
import React, { useState } from 'react';
import './Calendar.css';

// ✅ isExceptionallyClosed vient du parent (Booking.js) — pas de hook ici
const Calendar = ({
  onSelectDate,
  selectedDate,
  isExceptionallyClosed = () => false
}) => {
  const [currentMonth, setCurrentMonth] = useState(new Date());

  const getDaysInMonth    = (date) => new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  const getFirstDayOfMonth = (date) => new Date(date.getFullYear(), date.getMonth(), 1).getDay();

  const goToPreviousMonth = () => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1));
  const goToNextMonth     = () => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1));

  const toDateStr = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  };

  const isPast = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date < today;
  };

  const isToday    = (date) => date.toDateString() === new Date().toDateString();
  const isSelected = (date) => selectedDate && toDateStr(date) === selectedDate;

  const handleSelectDate = (day) => {
    const date    = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), day);
    const dateStr = toDateStr(date);
    if (isPast(date) || isExceptionallyClosed(dateStr)) return;
    onSelectDate(dateStr);
  };

  const canGoPrevious = () => {
    const today = new Date();
    const prev  = new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1);
    return prev >= new Date(today.getFullYear(), today.getMonth());
  };

  const generateCalendarDays = () => {
    const daysInMonth = getDaysInMonth(currentMonth);
    const firstDay    = getFirstDayOfMonth(currentMonth);
    const days        = [];

    for (let i = 0; i < firstDay; i++) {
      days.push(<div key={`empty-${i}`} className="calendar-day empty" />);
    }

    for (let day = 1; day <= daysInMonth; day++) {
      const date    = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), day);
      const dateStr = toDateStr(date);
      const past    = isPast(date);
      const closed  = !past && isExceptionallyClosed(dateStr);

      days.push(
        <button
          key={day}
          className={[
            'calendar-day',
            past    ? 'disabled'            : '',
            closed  ? 'exceptional-closure' : '',
            isSelected(date) ? 'selected'  : '',
            isToday(date)    ? 'today'      : ''
          ].filter(Boolean).join(' ')}
          onClick={() => handleSelectDate(day)}
          disabled={past || closed}
          title={closed ? 'Fermeture exceptionnelle' : undefined}
        >
          {day}
          {closed && <span className="closure-dot" />}
        </button>
      );
    }

    return days;
  };

  const monthNames = ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];
  const dayNames   = ['Dim','Lun','Mar','Mer','Jeu','Ven','Sam'];

  return (
    <div className="calendar-container">
      <div className="calendar-header">
        <button className="calendar-nav-btn" onClick={goToPreviousMonth} disabled={!canGoPrevious()}>‹</button>
        <h3 className="calendar-month">{monthNames[currentMonth.getMonth()]} {currentMonth.getFullYear()}</h3>
        <button className="calendar-nav-btn" onClick={goToNextMonth}>›</button>
      </div>

      <div className="calendar-weekdays">
        {dayNames.map(d => <div key={d} className="calendar-weekday">{d}</div>)}
      </div>

      <div className="calendar-days">{generateCalendarDays()}</div>

      <div className="calendar-legend">
        <span className="legend-item">
          <span className="legend-dot exceptional-closure-legend" />
          Fermeture exceptionnelle
        </span>
      </div>
    </div>
  );
};

export default Calendar;